// extracted by mini-css-extract-plugin
export default {"root":"EntityItem_root__5lMI4","primary":"EntityItem_primary__3KsPA","active":"EntityItem_active__dbaYy","secondary":"EntityItem_secondary__fetpx"};